<template>
  <div class="login">
    <div class="main">
      <div class="main-bg"></div>
      <div class="main_top">
        <!-- 登录 -->
        <div v-if="showName == '1'" class="form-input">
          <LoginPage @nameClick="nameClick" />
        </div>
        <!-- 注册 -->
        <div v-if="showName == '2'">
          <RegisteredPage :showName.sync="showName" />
        </div>
        <!-- 忘记密码 -->
        <div v-if="showName == '3'">
          <ResetPassword :showName.sync="showName" />
        </div>
        <!-- 微信1/qq2/钉钉3 -->
        <!-- <el-row class="main_footer">
          <a :href="wxUrl">
            <el-button @click="loginBtn(1)" circle>
              <img src="@/assets/img/login/wx.png" alt="" />
            </el-button>
          </a>
          <a :href="qqUrl">
            <el-button @click="loginBtn(2)" circle>
              <img src="@/assets/img/login/qq.png" alt="" />
            </el-button>
          </a>
          <a :href="ddUrl">
            <el-button @click="loginBtn(3)" circle>
              <img src="@/assets/img/login/dd.png" alt="" />
            </el-button>
          </a>
        </el-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/util/index";
import { getDdCode, getQqCode, getWxCode } from "@/network/loginRequest/api";

import LoginPage from "./components/loginPage/LoginPage";
import RegisteredPage from "./components/registeredPage/RegisteredPage";
import ResetPassword from "./components/resetPassword/ResetPassword";
import FromInput from "./components/loginPage/FromInput";
import MFromInput from "./components/loginPage/MFromInput";

export default {
  name: "Login",
  data() {
    return {
      WechatLoginURL: require("@/assets/img/login/Sign_weixin.png"),
      PhoneLoginURL: require("@/assets/img/login/Sign_phone.png"),
      isShow: "",
      showName: "1",
      ddUrl: null,
      wxUrl: null,
      qqUrl: null,
    };
  },
  components: {
    LoginPage,
    RegisteredPage,
    ResetPassword,
    FromInput,
    MFromInput,
  },

  methods: {
    nameClick(value) {
      switch (value) {
        case "注册新用户":
          this.showName = "2";
          break;
        case "忘记密码？":
          this.showName = "3";
          break;

        default:
          this.showName = "1";
          break;
      }
    },

    loginBtn(type) {
      utils.setSess("loginType", type);
      //第三方登录  0 微信 1 qq  3钉钉
      // if (type == 1) {
      //   utils.setSess("loginType", "1");
      // }

      // if (type == 2) {
      //   utils.setSess("loginType", "2");
      // }

      // if (type == 3) {
      //   utils.setSess("loginType", "3");
      // }
    },

    login() {
      if (this.ddUrl == null) {
        utils.tips("error", "打开失败，请检查网络");
      }
    },
  },

  created() {
    //判断是否存在登录状态 7天保存
    // console.log('二次登录',utils.getCookie("loginMessage"))
    if (utils.getCookie("loginMessage") && !utils.getSess("loginMessage")) {
      //修改vuex的登录状态
      this.$store.commit("isLogin", true);
      //修改用户id
      this.$store.commit("setUserId", utils.getCookie("userId"));
      //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
      utils.setSess("store", JSON.stringify(this.$store.state));
      //把token设置到sessionStorage里面
      utils.setSess("loginMessage", utils.getCookie("loginMessage"));
      //  console.log('ling==',21111)
      // this.$router.push("/home");
      this.$router.push({
        name: "ResourceCenter",
      });
    }

    getDdCode().then((res) => {
      this.ddUrl = res.data.url;
    });

    getQqCode().then((res) => {
      this.qqUrl = res.data.url;
    });

    getWxCode().then((res) => {
      this.wxUrl = res.data.url;
    });
  },

  beforeMount() {
    //访问注册
    console.log("showName", this.$route.query.showName);
    if (this.$route.query.showName) {
      this.showName = this.$route.query.showName;
    }
  },
};
</script>

<style lang="less" scoped>
.test {
  width: 500px;
  height: 500px;
  background-color: #fff;
}

.login {
  min-width: 1338px;
  height: 100vh;
  background-image: url("../../assets/img/login/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  .main {
    width: 840px;
    height: 460px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -230px;
    margin-left: -420px;
    display: flex;
    border-radius: 10px;
    box-shadow: 0 0 20px #ccc;
    overflow: hidden;

    .main-bg {
      flex: 1;
      height: 460px;
      background-image: url("../../assets/img/login/mainbg.png");
      background-repeat: no-repeat;
      background-size: 100% 460px;
    }

    .main_top {
      width: 420px;
      height: 460px;
      position: relative;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      .form-input {
        margin: 0 30px;
      }
      a:nth-child(3) {
        margin: 0;
      }

      //微信/qq/微博
      .main_footer {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-115px);
        display: flex;
        justify-content: center;

        .el-button {
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 0;
          position: relative;

          .codeImg {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100px;
            height: 100px;
            border: 1px solid #ccc;
          }
        }
      }
    }
  }
}
</style>
